<template>
    <div style="margin-top: 15px">
        <el-input v-model="search_data" :placeholder="$t('message.placeholder.input')" style="width: 42%; margin-left: 10px"
            @keyup.enter.native="searchSimple" size="small">
        </el-input>
        <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px" @click="searchSimple">{{
            $t("message.button.search") }}</el-button>
        <el-button type="success" icon="el-icon-folder-checked" v-show="baseId != 104" size="small"
            style="margin-left: 10px" @click="checkData">{{ $t("message.button.submit") }}</el-button>
        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" style="margin-left: 10px"
            @click="createNew = true" :disabled='isCreated'>{{ $t("message.button.create") }}</el-button>
        <el-dialog v-if='createNew' :title="$t('message.title.create')" :visible.sync="createNew"
            :before-close="handleClose" append-to-body>
            <Create :baseClass='select_value' :saveUrl="saveTableUrl" v-if='createNew' @addToList='cc'
            @closeCreateNew='createNew = false'></Create>
        </el-dialog>
        <vxe-grid ref="xGrid" v-bind="addTableList" @cell-dblclick="dbClick" @radio-change="radioChangeEvent"
            style="margin-top:15px">
        </vxe-grid>
        <el-pagination small v-if="paginationShow" class="pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next, jumper"
            :total="totalRecords">
        </el-pagination>
    </div>
</template>

<script>
import axios from "axios";
import Create from "./common/Create.vue";
export default {

    data() {
        return {
            search_data: "",
            select_value: "",
            input: "",
            select: "",
            pageSizes: [500, 1000],
            pageSize: 500,
            currentPage: 1,
            totalRecords: 0,
            paginationShow: true,
            options: [],
            searchVal: "",
            get_change_info: "",
            tableColumn: [],
            tableShow: false,
            oldTableValue: [],
            tableData: [],
            cols: [],

            addTableList: {
                keepSource: true,
                resizable: true,
                border: true,
                stripe: true,
                highlightHoverRow: true,
                highlightCurrentRow: true,
                showHeaderOverflow: true,
                showOverflow: true,
                rowId: "id",
                height: "370",
                size: "small",
                columns: [],
                data: [],
                editConfig: {
                    trigger: "dblclick",
                    mode: "row",
                    showIcon: false,
                    showStatus: true,
                },
                radioConfig: { highlight: true },
            },

            createNew: false,
            saveTableUrl: '',
            saveUrl: [
                { id: 501, url: "/pmdm/items/saveItemP1P2P3" },
            ],
        };
    },
    components: { Create },
    props: ["baseId",],
    methods: {
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchSimple();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchSimple();
        },
        handleClose(done) {
            this.$confirm(this.$t('message.confirm.close'))
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        cc(e) {
            console.log(e);
            this.createNew = false;
            this.$emit('listDbClick', e)
        },
        dbClick(row) {
            console.log(row.row);
            let arr = [row.row];
            this.$emit("listDbClick", arr);
        },
        radioChangeEvent({ row }) {
            this.$emit('getChangeInfo', [row])
        },
        checkData() {
            let removeRow = this.$refs.xGrid.getCheckboxRecords();
            console.log(removeRow);
            if (removeRow.length == 0) return false;
            this.$emit("listDbClick", removeRow);
        },
        getSearchSelect() {
            axios.get("/pmdm/admin/cls/getBaseClses").then((res) => {
                this.options = res.data.object.baseClses;
                for (var i = 0; i < res.data.object.baseClses.length; i++) {
                    if (res.data.object.baseClses[i].id == 501) {
                        this.select_value = this.options[i].id;
                        this.saveTableUrl = this.saveUrl.find(i => i.id == this.select_value).url;
                    }
                }
            });
        },
        searchSimple() {
            var obj_get = {
                //获取url参数
                baseClassId: this.select_value,
                value: this.search_data,
                size: this.pageSize,
                page: this.currentPage,
            };
            var loadTableUrl = '/pmdm/search/simple';
            axios.get(`${loadTableUrl + this.params(obj_get)}`).then((res) => {
                if (res.data.code == 200) {
                    this.totalRecords = res.data.object.table.totalRecords;
                    if (this.totalRecords == 0) {
                        this.$message({
                            showClose: true,
                            message: this.$t("message.warning.searchErr_02"),
                            type: "warning",
                        });
                        this.addTableList.data = [];
                        return;
                    }
                    let items = res.data.object.table.columnInfo.names;
                    this.cols = items.map((item, index) => {
                        return { field: index, title: item };
                    });
                    let colBox = [
                        {
                            type: this.baseId == 104 ? 'radio' : "checkbox",
                            width: 50,
                            fixed: null,
                        },
                    ];
                    this.addTableList.columns = [...colBox, ...this.cols];
                    items = res.data.object.table.rows;
                    let arr = [];
                    for (var i = 0; i < items.length; i++) {
                        var rols_ = {};
                        rols_.authTag = items[i].authTag;
                        for (var j = 0; j < items[0].cells.length; j++) {
                            rols_[j] = items[i].cells[j]?.val || '';
                            rols_["itemSubClass"] = items[i].objSubClass;
                            rols_["itemClass"] = items[i].objClass;
                            rols_["itemId"] = items[i].objId;
                        }
                        arr.push(rols_);
                    }
                    this.addTableList.data = arr;
                }
            });
        },
    },
    computed: {
        isCreated() {
            return this.select_value == 901 || this.select_value == 902
        }
    },
    created() {
        this.getSearchSelect();
    },
};
</script>
  
<style scoped>
.table {
    height: 530px;
    overflow: auto;
}

.el-select .el-input {
    width: 90px !important;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}</style>